import { createStyles, makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles(() =>
  createStyles({
    attachmentBox: {
      border: '1px solid #ced4da',
      borderRadius: '3px',
      display: 'flex',
      alignItems: 'center',
      width: '260px',
      padding: '3px',
    },
    fileName: {
      fontWeight: 400,
    },
    size: {
      color: '#2C2D3ECC',
      marginTop: '-3px',
      fontSize: '14px',
    },
  }),
);
